var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.user && _vm.user.id)?_c('div',{staticClass:"design-user-round"},[_c('VUserAvatar',{attrs:{"user":_vm.user}}),(_vm.showName)?_c('div',{staticClass:"design-user-round__name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }